export enum ViewPresetId {
  Month = 'month',
  MonthZoomed = 'month-zoomed',
  Week = 'week',
  WeekZoomed = 'week-zoomed',
  Day = 'day',
  DayZoomed = 'day-zoomed',
}
